import React from 'react';
import classNames from 'classnames';
import {
  TableRowProps,
  TableCellProps,
  HeadItem,
  TableProps,
} from '@/components/common/base/baseTableType';

export type { HeadItem };

export const HeadRow = ({ className, children, ...props }: TableRowProps) => {
  return (
    <ul
      className={classNames(['table-row w-full bg-green-19a698'], className)}
      {...props}
    >
      {children}
    </ul>
  );
};

export const HeadCell = ({
  className,
  children,
  cellAlign = 'middle',
  hasPadding = false,
  ...props
}: TableCellProps) => {
  return (
    <li
      className={classNames(
        'table-cell font-bold text-[14px] h-[40px] border-r border-green-182c2a last-of-type:border-r-0 text-white select-none',
        cellAlign === 'top' && 'align-top',
        cellAlign === 'middle' && 'align-middle',
        hasPadding && 'px-[10px]',
        className
      )}
      {...props}
    >
      {children}
    </li>
  );
};

export const TableRow = ({ className, children, ...props }: TableRowProps) => {
  return (
    <ul
      className={classNames(['table-row w-full bg-green-4e6d6a hover:bg-gray-666', className])}
      {...props}
    >
      {children}
    </ul>
  );
};

export const TableCell = ({
  className,
  children,
  cellAlign = 'middle',
  hasPadding = true,
  ...props
}: TableCellProps) => {
  return (
    <li
      className={classNames(
        'table-cell relative  border-r border-r-gray-111 border-b border-b-gray-111 last-of-type:border-r-0 h-[42px]',
        cellAlign === 'top' && 'align-top',
        cellAlign === 'middle' && 'align-middle',
        hasPadding && 'px-[10px]',
        className
      )}
      {...props}
    >
      {children}
    </li>
  );
};

export const SecondayTable = ({
  isCustomHeader = false,
  isHeightFull = false,
  customHeader,
  children,
  className,
  headList,
}: TableProps) => {
  return (
    <div
      className={classNames(
        'relative w-full border-separate rounded-[8px] overflow-x-auto scrollbar-primary',
        isHeightFull && 'h-full',
        className
      )}
    >
      <div className={classNames('table w-full', isHeightFull && 'h-full')}>
        <div className="table-row-group">
          {/*
            head
          */}
          {!isCustomHeader && (
            <HeadRow>
              {headList.map(headItem => (
                <HeadCell
                  key={headItem.key}
                  className="px-[8px]"
                  style={headItem.style}
                >
                  {headItem.label}
                </HeadCell>
              ))}
            </HeadRow>
          )}

          {isCustomHeader && <>{customHeader}</>}

          {/*
            body
          */}
          {children}
        </div>
      </div>
    </div>
  );
};
